import React from 'react';

import { Box } from '@chakra-ui/react';

const DisplayInfo = ({ children, bgcolor = 'none' }) => (
  <Box width="100%" padding="2rem" display="flex" justifyContent="center" bgColor={bgcolor}>
    {children}
  </Box>
);

export default DisplayInfo;
